import { useContext } from "react";
import { CardDataContext } from "../../../../utils/context";
import { ReactComponent as HideIcon } from "./hideIcon.svg";
import { useRecoilState } from "recoil";
import { cardsAtom } from "../../../../store";
import { likeCard } from "../../../../utils/net";

const HideCard = ({
  isMe, selectedFilter
}) => {
  const { task_uuid } = useContext<{
    task_uuid: string
  }>(CardDataContext);
  const [cards, setCards] = useRecoilState<{
    task_uuid: string
  }[]>(cardsAtom);

  if (!isMe) {
    return null;
  }

  const handleLikeClick = async () => {
    const newCards = JSON.parse(JSON.stringify(cards));
    const index = cards.findIndex((item) => item.task_uuid === task_uuid);
    if (index === -1) return;
    newCards[index].is_hidden = !selectedFilter.Hide?.status;
    setCards(newCards);
    likeCard({ task_uuid, operation: selectedFilter.Hide?.status ? "Unhide" : "Hide" });
  };
  return (
    <button
      onClick={() => handleLikeClick()}
      className={`w-[40px] h-[40px] rounded-xl active:scale-95  transition-300-ease backdrop-blur cursor-pointer 2 flex-center ${
        selectedFilter.Hide?.status
          ? "text-[#0590DF] bg-[rgba(5,144,223,0.15)] hover:bg-[rgba(5,144,223,0.25)]"
          : "bg-[#FFFFFF26] text-[#E0E0E0] hover:text-white hover:bg-[rgba(255,255,255,0.25)]"
      }`}
    >
      <HideIcon />
    </button>
  );
};

export default HideCard;
